module.exports = __webpack_public_path__ + "static/media/b_3.bfc47626.jpg";